
import { Mixins, Component, Prop, Ref } from "vue-property-decorator";
import { SmartText, CTAButton, WYSIWYG } from "_components";
import { createModifierClass, generateID } from "_utils";
import { GSAP, config } from "_core";
import { onResize } from "_mixins";
import { EventTakeoverType } from "../../types";

import Shader from "./Shader/index.vue";
import Background from "./Background/index.vue";
import HeroText from "./HeroText.vue";

@Component({
  name: "HomepageEventTakeover",
  components: { SmartText, CTAButton, Shader, Background, HeroText, WYSIWYG },
})
export default class HomepageEventTakeover extends Mixins(onResize) {
  @Ref() shaderRef: Shader;
  @Ref() backgroundRef: Background;
  @Ref() heroRef: HTMLElement;
  @Ref() textRef: HTMLElement;
  @Ref() fadeRef: HTMLElement;

  @Prop() data: EventTakeoverType;
  rootClass = "p-event-takeover";

  loadCounter = 0;
  private tl: gsap.core.Timeline;

  isVisible = false;
  isMobile = false;

  get classes() {
    return [
      this.rootClass,
      createModifierClass(this.rootClass, true, this.data.primary_colour),
      createModifierClass(this.rootClass, this.isVisible, "is-visible"),
    ];
  }

  get ID() {
    return generateID();
  }

  get buttons() {
    return this.data && this.data.buttons;
  }

  get visualData() {
    return this.data && this.data.visual;
  }

  get preface() {
    return this.data && this.data.text_keys.title_preface;
  }

  get title() {
    return this.data && this.data.text_keys.title;
  }

  get text() {
    return this.data && this.data.text_keys.bottom_left_corner;
  }

  onResize() {
    this.calcScreenWidth();
  }

  calcScreenWidth() {
    this.isMobile = window.innerWidth < config.mobBreakpoint;
  }

  beforeMount() {
    this.calcScreenWidth();
  }

  handleLoad() {
    if (this.loadCounter > 1) return;
    this.loadCounter += 1;
    if (this.loadCounter === 2) this.init();
  }

  init() {
    this.isVisible = true;
    this.tl = GSAP.timeline();
    this.tl.fromTo(
      [this.backgroundRef.$el, this.shaderRef.$el.children[0]],
      { y: 100, opacity: 0, scale: "1.1" },
      { y: 0, opacity: 1, scale: 1, duration: 5, stagger: 1 }
    );

    this.tl.fromTo(
      [this.heroRef.children].flat(),
      { y: 100, opacity: 0, scale: "1.1" },
      { y: 0, opacity: 1, scale: 1, duration: 2, stagger: 0.2, delay: -6 }
    );
    this.tl.fromTo(
      this.textRef,
      { y: 100, opacity: 0 },
      { y: 0, opacity: 1, duration: 2, stagger: 0.2, delay: -6 }
    );
    this.tl.fromTo(
      this.fadeRef,
      { opacity: 1 },
      { opacity: 0, duration: 4, stagger: 0.2, delay: -3 }
    );
  }
}
